export { renderNewRelicSnippet } from './new-relic-snippet';
export { renderFavicons } from './favicon';
//# sourceMappingURL=index.js.map